// NOVAPAY-116-RC3-R1 — direct-browser public legal viewer (shared ProfileV2 document surface).
import { useEffect, useState } from "react";
import { ProfileV2, LanguageSwitch } from "./about-v2.js";
import type { LegalHubPanel } from "./legal-document-registry-v2.js";
import { applyStoreV2Theme, cycleStoreV2Theme, readStoreV2Theme, type StoreV2Theme } from "./theme-v2.js";
import { readStoreV2Lang, writeStoreV2Lang, type StoreV2Lang } from "./store-v2-locale.js";
import { QuickScrollControls } from "./quick-scroll-v2.js";
import { setLegalNavContext } from "./legal-nav-context-v2.js";
import { StoreV2GlobalClose } from "./components.js";

export function PublicLegalViewer({ initialPanel }: { initialPanel: LegalHubPanel }) {
  const [lang, setLang] = useState<StoreV2Lang>(() => readStoreV2Lang());
  const [theme, setTheme] = useState<StoreV2Theme>(() => readStoreV2Theme());

  useEffect(() => {
    applyStoreV2Theme(theme);
    setLegalNavContext({
      source: "public",
      returnScrollTop: 0,
      skipHubOnDocumentBack: false,
    });
  }, [theme]);

  return (
    <div className="sv2-root sv2-public-legal" data-public-legal="true" data-testid="sv2-public-legal-root" data-store-scroll-root="true">
      <header className="sv2-public-legal-head">
        <StoreV2GlobalClose lang={lang} routeClass="public_legal" />
        <span className="sv2-section-title">AsiaStyle · {lang === "en" ? "Legal" : "Документи"}</span>
        <div className="sv2-public-legal-tools">
          <LanguageSwitch
            lang={lang}
            onLangChange={(next) => {
              writeStoreV2Lang(next);
              setLang(next);
            }}
          />
          <button
            type="button"
            className="sv2-navbtn"
            onClick={() => setTheme((t) => cycleStoreV2Theme(t))}
            aria-label="Theme"
          >
            {theme === "dark" ? "☾" : theme === "light" ? "☀" : "◐"}
          </button>
        </div>
      </header>
      <ProfileV2
        buildId=""
        lang={lang}
        hideTechnicalDiagnostics
        initialLegalPanel={initialPanel}
        onLangChange={(next) => {
          writeStoreV2Lang(next);
          setLang(next);
        }}
        theme={theme}
        onThemeCycle={() => setTheme((t) => cycleStoreV2Theme(t))}
      />
      <QuickScrollControls lang={lang} />
    </div>
  );
}
